import { Directive } from '@angular/core';

@Directive({
    selector: '[smoothWidth]',
    standalone: true,
})
export class SmoothWidthDirective {}
